module.exports = __webpack_public_path__ + "img/symbol_4.bbceb3d7.png";